<template>
  <header class="app-page-header" :class="{ 'app-page-header--new': design === 'new', 'app-page-header--compact': compact }">
    <div class="app-page-header__copy">
      <div v-if="$slots.eyebrow" class="app-page-header__eyebrow">
        <slot name="eyebrow" />
      </div>
      <component :is="titleTag" class="app-page-header__title">{{ title }}</component>
      <p v-if="subtitle" class="app-page-header__subtitle">{{ subtitle }}</p>
      <slot name="subtitle" />
      <div v-if="$slots.create" class="app-page-header__create">
        <slot name="create" />
      </div>
    </div>
    <div v-if="$slots.actions" class="app-page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppPageHeader',
  props: {
    compact: Boolean,
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    titleTag: {
      type: String,
      default: 'h1',
      validator: value => ['h1', 'h2'].includes(value)
    },
    design: {
      type: String,
      required: true,
      validator: value => value === 'new'
    }
  }
}
</script>

<style lang="scss" scoped>
.app-page-header--new {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: $ui-space-24;
  margin-bottom: $ui-space-24;
  color: $ui-text;
  font-family: $ui-font-body;

  .app-page-header__copy {
    min-width: 0;
  }

  .app-page-header__title {
    margin: 0;
    color: $ui-ink;
    font-family: $ui-font-heading;
    font-size: $ui-font-size-page-title;
    font-weight: 600;
    line-height: 1.1;
  }

  .app-page-header__subtitle {
    margin: $ui-space-4 0 0;
    color: $ui-muted;
    font-size: $ui-font-size-body;
    line-height: 1.45;
  }

  .app-page-header__eyebrow {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: $ui-space-8;
    margin-bottom: $ui-space-8;
  }

  .app-page-header__actions {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: $ui-space-12;
  }

  .app-page-header__create {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: $ui-space-12;
    margin-top: $ui-space-12;
  }
}

.app-page-header--new.app-page-header--compact { margin-bottom: $ui-space-12; }

@media (max-width: 760px) {
  .app-page-header--new {
    align-items: stretch;
    flex-direction: column;
    gap: $ui-space-16;

    .app-page-header__actions {
      justify-content: flex-start;
    }
  }
}

@media (max-width: 600px) {
  .app-page-header--new .app-page-header__title {
    font-size: $ui-font-size-entity-title;
  }
}
</style>
